import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import {
  cartTopRefUpdate,
  cartBottomRefUpdate,
  cartTypeUpdate,
} from "../../store/actions/cartPosition";
import { removeCart } from "../../store/actions/cart";
import { Link } from "react-router-dom";
import styles from "../../thema/style";
import { PUBLIC_URL } from "../../config";
import calculatePrice from "../../helpers/calculatePrice";
import activeDiscount from "../../helpers/activeDiscount";
class Cart extends Component {
  state = {
    cart: false,
    cartDetailTop: false,
    cartDetailBottom: false,
    cartPriceDetail: false,
  };

  constructor(props) {
    super(props);
    this.cartTop = React.createRef();
    this.cartBottom = React.createRef();
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    this.props.cartTopRefUpdate(this.cartTop);
    this.props.cartBottomRefUpdate(this.cartBottom);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const { bottom } = this.cartTop.current.getBoundingClientRect();
    if (bottom < 0) {
      if (!this.state.cart) {
        this.props.cartTypeUpdate("Bottom");
        this.setState({
          cart: true,
          cartDetailTop: false,
          cartDetailBottom: false,
        });
      }
    } else {
      if (this.state.cart) {
        this.props.cartTypeUpdate("Top");
        this.setState({
          cart: false,
          cartDetailTop: false,
          cartDetailBottom: false,
        });
      }
    }

    // const { bottom } = this.cartTopRef; //this.cart.getBoundingClientRect();
    //
    // if (bottom < 0) {
    //   if (!this.state.cart) {
    //     this.props.cartTypeUpdate("Bottom");
    //     this.setState({ cart: true });
    //   }
    // } else {
    //   if (this.state.cart) {
    //     this.props.cartTypeUpdate("Top");
    //     this.setState({ cart: false });
    //   }
    // }
  };

  renderCartDetail() {
    if (this.props.cart.items.length > 0) {
      return (
        <div style={{ height: 300, overflow: "scroll" }}>
          <ul className={styles.cartWrapperDetail}>
            {this.props.cart.items.map((item, i) => (
              <li key={i}>
                <div className="product-thumb">
                  <Link
                    to={{
                      pathname: `/urun/${item.slug}`,
                      state: { product: item },
                    }}
                  >
                    <img src={PUBLIC_URL(item.image)} />
                  </Link>
                </div>
                <div className="product-detail">
                  <div className="product-name">
                    <Link
                      to={{
                        pathname: `/urun/${item.slug}`,
                        state: { product: item },
                      }}
                    >
                      {item.name}
                    </Link>
                  </div>
                  <div className="product-price">
                    {/* {item.quantity} x ₺
                    {item.sale_price ? item.sale_price : item.price} */}

                    <span
                      style={{
                        color: "#ccc",
                        textDecoration: activeDiscount(item.categories)
                          ? "line-through"
                          : "none",
                      }}
                    >
                      ₺
                      {item.sale_price
                        ? parseFloat(item.sale_price).toFixed(2)
                        : parseFloat(item.price).toFixed(2)}
                    </span>
                    {activeDiscount(item.categories) ? (
                      <React.Fragment>
                        <br />₺
                        {activeDiscount(item.categories).type === "percent"
                          ? item.sale_price
                            ? parseFloat(
                                item.sale_price *
                                  (1 -
                                    activeDiscount(item.categories).discount /
                                      100)
                              ).toFixed(2)
                            : parseFloat(
                                item.price *
                                  (1 -
                                    activeDiscount(item.categories).discount /
                                      100)
                              ).toFixed(2)
                          : item.sale_price
                          ? parseFloat(
                              item.sale_price -
                                activeDiscount(item.categories).discount
                            ).toFixed(2)
                          : parseFloat(
                              item.price -
                                activeDiscount(item.categories).discount
                            ).toFixed(2)}
                      </React.Fragment>
                    ) : null}
                  </div>
                </div>
                <div className="product-action">
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      if (
                        window.confirm(
                          `${item.name} ürününü sepetinizden çıkartmak istediğinize eminmisiniz?`
                        )
                      )
                        this.props.removeCart(item);
                    }}
                  >
                    <FontAwesomeIcon icon={["fas", "times"]} />
                  </button>
                </div>
              </li>
            ))}
          </ul>
        </div>
      );
    } else {
      return <div className={"empty-cart"}>Sepete Ürün Eklenmemiş</div>;
    }
  }

  render() {
    const cartTotalDiscountPrice =
      this.props.cart.items.length > 0
        ? parseFloat(
            this.props.cart.items
              .map((product) =>
                parseFloat(
                  calculatePrice(product, activeDiscount(product.categories))
                )
              )
              .reduce((a, b) => a + b)
              .toFixed(2)
          )
        : 0;

    const cartTotalPrice =
      this.props.cart.items.length > 0
        ? parseFloat(
            this.props.cart.items
              .map((item) =>
                item.sale_price
                  ? item.quantity * item.sale_price
                  : item.quantity * item.price
              )
              .reduce((a, b) => a + b)
              .toFixed(2)
          )
        : 0;

    return (
      <React.Fragment>
        <div className={styles.cartWrapper}>
          <div
            ref={this.cartTop}
            onClick={() => {
              this.setState({ cartDetailTop: !this.state.cartDetailTop });
            }}
            className={"cart"}
          >
            {!this.state.cartDetailTop ? (
              <FontAwesomeIcon
                icon={["fas", "shopping-basket"]}
                color={"#7fb401"}
                size={"lg"}
              />
            ) : (
              <FontAwesomeIcon
                icon={["fas", "times"]}
                color={"#7fb401"}
                size={"lg"}
              />
            )}
            <span>
              {this.props.cart.items.length > 0
                ? this.props.cart.items
                    .map((v) => v.quantity)
                    .reduce((a, b) => a + b)
                : 0}
            </span>
          </div>
          <div className={"cart-info"}>
            <div>
              <Link
                to={"/sepet"}
                onClick={() => {
                  this.setState({
                    cartDetailTop: false,
                    cartDetailBottom: false,
                  });
                }}
              >
                Sepetim
              </Link>
            </div>
            <div className={"price"}>
              ₺
              {cartTotalPrice > 0
                ? cartTotalPrice +
                  (cartTotalPrice >= this.props.setting.setting.free_shipping
                    ? 0
                    : this.props.setting.setting.shipping_cost)
                : 0}
            </div>
          </div>

          {this.state.cartDetailTop && (
            <div className={"cart-detail"}>
              {this.renderCartDetail()}
              <div
                style={{
                  height: this.state.cartPriceDetail ? "auto" : 0,
                  overflow: "hidden",
                }}
              >
                <hr style={{ margin: 0, padding: 0 }} />
                <div className="cart-bottom-price-detail">
                  <div>
                    Ara Toplam:
                    <span>₺{parseFloat(cartTotalPrice).toFixed(2)}</span>
                  </div>
                  {/* {cartTotalPrice > 0 ? (
                    <div>
                      Kargo:{" "}
                      <span>₺{this.props.setting.setting.shipping_cost}</span>
                    </div>
                  ) : null} */}

                  {cartTotalPrice > 0 ? (
                    <div>
                      Kargo
                      {cartTotalPrice >=
                      this.props.setting.setting.free_shipping ? (
                        <small style={{ marginLeft: 5, fontStyle: "italic" }}>
                          {parseFloat(
                            this.props.setting.setting.free_shipping
                          ).toFixed(2)}{" "}
                          TL ve Üzeri Ücretsiz Kargo
                        </small>
                      ) : null}
                      :{" "}
                      <span>
                        ₺
                        {cartTotalPrice >=
                        this.props.setting.setting.free_shipping
                          ? 0
                          : parseFloat(
                              this.props.setting.setting.shipping_cost
                            ).toFixed(2)}
                      </span>
                    </div>
                  ) : null}

                  {cartTotalPrice - cartTotalDiscountPrice > 0 ? (
                    <div>
                      Sepette İndirim:
                      <span style={{ color: "#c00" }}>
                        -₺
                        {parseFloat(
                          cartTotalPrice - cartTotalDiscountPrice
                        ).toFixed(2)}
                      </span>
                    </div>
                  ) : null}
                </div>
              </div>
              <hr style={{ margin: 0, padding: 0 }} />
              <div className={"cart-detail-footer"}>
                <span
                  onClick={() => {
                    this.setState({
                      cartPriceDetail: !this.state.cartPriceDetail,
                    });
                  }}
                  className={"total"}
                >
                  <FontAwesomeIcon
                    icon={[
                      "fas",
                      this.state.cartPriceDetail
                        ? "fa-chevron-up"
                        : "fa-chevron-down",
                    ]}
                  />{" "}
                  Toplam: ₺
                  {parseFloat(
                    cartTotalDiscountPrice > 0
                      ? cartTotalDiscountPrice +
                          (cartTotalDiscountPrice >=
                          this.props.setting.setting.free_shipping
                            ? 0
                            : this.props.setting.setting.shipping_cost)
                      : 0
                  ).toFixed(2)}
                </span>
                <Link
                  to="/sepet"
                  onClick={() => {
                    this.setState({
                      cartDetailTop: false,
                      cartDetailBottom: false,
                    });
                  }}
                >
                  Sepet Detayları
                </Link>
              </div>
            </div>
          )}
        </div>

        <div
          // cartPosition

          ref={this.cartBottom}
          className={`${styles.bottomCartWrapper} 
          ${
            this.props.setting.setting.cartPosition === "left"
              ? styles.cartPositionLeft
              : styles.cartPositionRight
          }
          `}
          style={
            this.state.cart
              ? { visibility: "visible", transform: "scale(1)" }
              : { opacity: 0 }
          }
        >
          <div
            onClick={() => {
              this.setState({ cartDetailBottom: !this.state.cartDetailBottom });
            }}
          >
            <span>
              {this.props.cart.items.length > 0
                ? this.props.cart.items
                    .map((v) => v.quantity)
                    .reduce((a, b) => a + b)
                : 0}
            </span>
            {!this.state.cartDetailBottom ? (
              <FontAwesomeIcon
                icon={["fas", "shopping-basket"]}
                color={"#7fb401"}
                size={"2x"}
              />
            ) : (
              <FontAwesomeIcon
                icon={["fas", "times"]}
                color={"#7fb401"}
                size={"2x"}
              />
            )}
          </div>

          {this.state.cartDetailBottom && (
            <div
              className={`cart-detail ${
                this.props.setting.setting.cartPosition === "left"
                  ? "right"
                  : "cart-detail left"
              }`}
            >
              {this.renderCartDetail()}

              <div
                style={{
                  height: this.state.cartPriceDetail ? "auto" : 0,
                  overflow: "hidden",
                }}
              >
                <hr style={{ margin: 0, padding: 0 }} />
                <div className="cart-bottom-price-detail">
                  <div>
                    Ara Toplam:
                    <span>₺{parseFloat(cartTotalPrice).toFixed(2)}</span>
                  </div>

                  {cartTotalPrice > 0 ? (
                    <div>
                      Kargo
                      {cartTotalPrice >=
                      this.props.setting.setting.free_shipping ? (
                        <small style={{ marginLeft: 5, fontStyle: "italic" }}>
                          {parseFloat(
                            this.props.setting.setting.free_shipping
                          ).toFixed(2)}{" "}
                          TL ve Üzeri Ücretsiz Kargo
                        </small>
                      ) : null}
                      :{" "}
                      <span>
                        ₺
                        {cartTotalPrice >=
                        this.props.setting.setting.free_shipping
                          ? 0
                          : parseFloat(
                              this.props.setting.setting.shipping_cost
                            ).toFixed(2)}
                      </span>
                    </div>
                  ) : null}

                  {cartTotalPrice - cartTotalDiscountPrice > 0 ? (
                    <div>
                      Sepette İndirim:
                      <span style={{ color: "#c00" }}>
                        -₺
                        {parseFloat(
                          cartTotalPrice - cartTotalDiscountPrice
                        ).toFixed(2)}
                      </span>
                    </div>
                  ) : null}
                </div>
              </div>

              <hr style={{ margin: 0, padding: 0 }} />
              <div className={"cart-detail-footer"}>
                <span
                  onClick={() => {
                    this.setState({
                      cartPriceDetail: !this.state.cartPriceDetail,
                    });
                  }}
                  className={"total"}
                >
                  <FontAwesomeIcon
                    icon={[
                      "fas",
                      this.state.cartPriceDetail
                        ? "fa-chevron-up"
                        : "fa-chevron-down",
                    ]}
                  />{" "}
                  Toplam: ₺
                  {parseFloat(
                    cartTotalDiscountPrice > 0
                      ? cartTotalDiscountPrice +
                          (cartTotalDiscountPrice >=
                          this.props.setting.setting.free_shipping
                            ? 0
                            : this.props.setting.setting.shipping_cost)
                      : 0
                  ).toFixed(2)}
                </span>
                <Link
                  to={"/sepet"}
                  onClick={() => {
                    this.setState({
                      cartDetailTop: false,
                      cartDetailBottom: false,
                    });
                  }}
                >
                  Sepet Detayları
                </Link>
              </div>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ cart, setting }) => {
  return { cart, setting };
};

const mapDispatchToProps = {
  removeCart,
  cartTopRefUpdate,
  cartBottomRefUpdate,
  cartTypeUpdate,
};

export default connect(mapStateToProps, mapDispatchToProps)(Cart);



// WEBPACK FOOTER //
// ./src/components/shared/Cart.js